const assets = [
  {
    id: 699371763,
    creator: '7SNDPEPR7APYXCARY2YD7ZM4XKLSOXU3ESDLCHXFQ66HLUFCBOAVIX5T3U',
    name: 'Shitty Litter Pan',
    unitName: 'SKA001',
    url: 'ipfs://bafybeifarcbzsk3uczk5vuaeoarplxu5tia4f7afwhdazpjx2uorp5oj5e#i',
    note: {
      json: {
        standard: 'arc69',
        mime_type: 'image/png',
        external_url: 'https://www.shittykitties.art',
        description: 'Shitty Kitties Accessories is a collection of NFTs used as rewards for holders of First and Second Litter Shitty Kitties NFTs.',
        properties: {
          Quantity: '50',
          Background: 'Yellow',
          'Minimum Kitties for Reward': '1',
        },
      },
    },
    enricher: {
      mediaLen: {
        $numberLong: '748178',
      },
      mediaType: 'image/png',
    },
  },
  {
    id: 700882175,
    creator: '7SNDPEPR7APYXCARY2YD7ZM4XKLSOXU3ESDLCHXFQ66HLUFCBOAVIX5T3U',
    name: 'Shitty Cat Tower',
    unitName: 'SKA002',
    url: 'ipfs://bafybeidjb2qu5jnyvevyqamlqv7sqvhbgjpup3v7tu3blxrzzqpl36ptje#i',
    note: {
      json: {
        standard: 'arc69',
        mime_type: 'image/png',
        description: 'Shitty Kitties Accessories is a collection of NFTs used as rewards for holders of First and Second Litter Shitty Kitties NFTs.',
        external_url: 'https://www.shittykitties.art',
        properties: {
          Quantity: '50',
          Background: 'Green',
          'Minimum Kitties for Reward': '1',
        },
      },
    },
    enricher: {
      mediaLen: {
        $numberLong: '639572',
      },
      mediaType: 'image/png',
    },
  },
  {
    id: 700882780,
    creator: '7SNDPEPR7APYXCARY2YD7ZM4XKLSOXU3ESDLCHXFQ66HLUFCBOAVIX5T3U',
    name: 'Less Shitty Cat Tower',
    total: {
      $numberLong: '10',
    },
    unitName: 'SKA003',
    url: 'ipfs://bafybeibywnhljpf7tm2t4ttgabe2wpjvqhssh2dacml6taiuimiueobfbq#i',
    note: {
      json: {
        standard: 'arc69',
        mime_type: 'image/png',
        description: 'Shitty Kitties Accessories is a collection of NFTs used as rewards for holders of First and Second Litter Shitty Kitties NFTs.',
        external_url: 'https://www.shittykitties.art',
        properties: {
          Quantity: '10',
          Background: 'Orange',
          'Minimum Kitties for Reward': '5',
        },
      },
    },
    enricher: {
      mediaLen: {
        $numberLong: '773043',
      },
      mediaType: 'image/png',
    },
  },
  {
    id: 704485483,
    creator: '7SNDPEPR7APYXCARY2YD7ZM4XKLSOXU3ESDLCHXFQ66HLUFCBOAVIX5T3U',
    name: 'Shitty Feather Toy',

    unitName: 'SKA004',
    url: 'ipfs://bafybeid352ismt6yzxmge55owuwmyap5qc6eyhityo3323u7sq7q4zbxm4#i',
    note: {
      json: {
        standard: 'arc69',
        mime_type: 'image/png',
        external_url: 'https://www.shittykitties.art/',
        description: 'Shitty Kitties Accessories is a collection of NFTs used as rewards for holders of First and Second Litter Shitty Kitties NFTs.',
        properties: {
          Quantity: '50',
          Background: 'Light Green',
          'Minimum Kitties for Reward': '1',
        },
      },
    },
    enricher: {
      mediaLen: {
        $numberLong: '1320531',
      },
      mediaType: 'image/png',
    },
  },
  {
    id: 704486275,
    creator: '7SNDPEPR7APYXCARY2YD7ZM4XKLSOXU3ESDLCHXFQ66HLUFCBOAVIX5T3U',
    name: 'Shitty Roller Toy',
    total: {
      $numberLong: '25',
    },
    unitName: 'SKA005',
    url: 'ipfs://bafybeibrvydtgf63pdoz2hywgvqxbrtzcbydff367qawqgn7iav34knkly#i',
    note: {
      json: {
        standard: 'arc69',
        mime_type: 'image/png',
        description: 'Shitty Kitties Accessories is a collection of NFTs used as rewards for holders of First and Second Litter Shitty Kitties NFTs.',
        external_url: 'https://www.shittykitties.art/',
        properties: {
          Quantity: '25',
          Background: 'Blue',
          'Minimum Kitties for Reward': '2',
        },
      },
    },
    enricher: {
      mediaLen: {
        $numberLong: '1275799',
      },
      mediaType: 'image/png',
    },
  },
  {
    id: 722364568,
    creator: '7SNDPEPR7APYXCARY2YD7ZM4XKLSOXU3ESDLCHXFQ66HLUFCBOAVIX5T3U',
    name: 'Shitty Food \u0026 Water Bowl',
    total: {
      $numberLong: '25',
    },
    unitName: 'SKA006',
    url: 'ipfs://bafybeif4oemlwvqbheqdefdfkj4cykb4ioksecruqekgutd7jr2ez4bczi#i',
    note: {
      json: {
        standard: 'arc69',
        mime_type: 'image/png',
        description: 'Shitty Kitties Accessories is a collection of NFTs used as rewards for holders of First and Second Litter Shitty Kitties NFTs.',
        external_url: 'https://www.shittykitties.art/',
        properties: {
          Quantity: '25',
          Background: 'Light Green',
          'Minimum Kitties for Reward': '3',
        },
      },
    },
    enricher: {
      mediaLen: {
        $numberLong: '905317',
      },
      mediaType: 'image/png',
    },
  },
  {
    id: 795387138,
    creator: '7SNDPEPR7APYXCARY2YD7ZM4XKLSOXU3ESDLCHXFQ66HLUFCBOAVIX5T3U',
    name: 'Shitty Cat Tunnel',
    total: {
      $numberLong: '16',
    },
    unitName: 'SKA007',
    url: 'ipfs://bafybeidq4celjtup2whoaycdaye5dewa2urq2swqwfi2f7clvgerrz6jha#i',
    note: {
      json: {
        standard: 'arc69',
        mime_type: 'image/png',
        external_url: 'https://www.shittykitties.art/',
        description: 'Shitty Kitties Accessories is a collection of NFTs used as rewards for holders of First and Second Litter Shitty Kitties NFTs.',
        properties: {
          Quantity: '16',
          Background: 'Red',
          'Minimum Kitties for Reward': '3',
        },
      },
    },
    enricher: {
      mediaLen: {
        $numberLong: '858577',
      },
      mediaType: 'image/png',
    },
  },
  {
    id: 809528563,
    creator: '7SNDPEPR7APYXCARY2YD7ZM4XKLSOXU3ESDLCHXFQ66HLUFCBOAVIX5T3U',
    name: 'Shitty Cat Bed',
    total: {
      $numberLong: '25',
    },
    unitName: 'SKA008',
    url: 'ipfs://bafybeibjlsxrrifvpvnhaesz24qqde3jtpllmvxvf43j4d64s5jxpa6hny#i',
    note: {
      json: {
        standard: 'arc69',
        mime_type: 'image/png',
        description: 'Shitty Kitties Accessories is a collection of NFTs used as rewards for holders of First and Second Litter Shitty Kitties NFTs.',
        external_url: 'https://www.shittykitties.art/',
        properties: {
          Quantity: '25',
          Background: 'Salmon',
          'Minimum Kitties for Reward': '2',
        },
      },
    },
    enricher: {
      mediaLen: {
        $numberLong: '719745',
      },
      mediaType: 'image/png',
    },
  },
  {
    id: 833778238,
    creator: '7SNDPEPR7APYXCARY2YD7ZM4XKLSOXU3ESDLCHXFQ66HLUFCBOAVIX5T3U',
    name: 'Shitty Balls',

    unitName: 'SKA009',
    url: 'ipfs://bafybeic3ggmyxvlwhygtbwz6ypcf4ugge3letm7d6cgwi62eh3jgzqdnay#i',
    note: {
      json: {
        standard: 'arc69',
        mime_type: 'image/png',
        description: 'Shitty Kitties Accessories is a collection of NFTs used as rewards for holders of First and Second Litter Shitty Kitties NFTs.',
        external_url: 'https://www.shittykitties.art/',
        properties: {
          Quantity: '50',
          Background: 'Blue',
          'Minimum Kitties for Reward': '1',
        },
      },
    },
    enricher: {
      mediaLen: {
        $numberLong: '932625',
      },
      mediaType: 'image/png',
    },
  },
  {
    id: 843747214,
    creator: '7SNDPEPR7APYXCARY2YD7ZM4XKLSOXU3ESDLCHXFQ66HLUFCBOAVIX5T3U',
    name: 'Less Shitty Cat Tower 2',
    total: {
      $numberLong: '10',
    },
    unitName: 'SKA010',
    url: 'ipfs://bafybeiasdutc6467kwgtwokoqpyabcdw57hpeuhaae4hony425hfxp3whm#i',
    note: {
      json: {
        standard: 'arc69',
        mime_type: 'image/png',
        description: 'Shitty Kitties Accessories is a collection of NFTs used as rewards for holders of First and Second Litter Shitty Kitties NFTs.',
        external_url: 'https://www.shittykitties.art',
        properties: {
          Quantity: '10',
          Background: 'Light Purple',
          'Minimum Kitties for Reward': '5',
        },
      },
    },
    enricher: {
      mediaLen: {
        $numberLong: '851874',
      },
      mediaType: 'image/png',
    },
  },
  {
    id: 844776290,
    creator: '7SNDPEPR7APYXCARY2YD7ZM4XKLSOXU3ESDLCHXFQ66HLUFCBOAVIX5T3U',
    name: 'Shitty Cat Hut',
    total: {
      $numberLong: '25',
    },
    unitName: 'SKA011',
    url: 'ipfs://bafybeifgh5i4it73gk4phoptzbtkkobbnyrfdqbyi7dn3b67owd36yvzci#i',
    note: {
      json: {
        standard: 'arc69',
        mime_type: 'image/png',
        description: 'Shitty Kitties Accessories is a collection of NFTs used as rewards for holders of First and Second Litter Shitty Kitties NFTs.',
        external_url: 'https://www.shittykitties.art',
        properties: {
          Quantity: '25',
          Background: 'Yellow',
          'Minimum Kitties for Reward': '2',
        },
      },
    },
    enricher: {
      mediaLen: {
        $numberLong: '799595',
      },
      mediaType: 'image/png',
    },
  },
  {
    id: 867652025,
    creator: '7SNDPEPR7APYXCARY2YD7ZM4XKLSOXU3ESDLCHXFQ66HLUFCBOAVIX5T3U',
    name: 'Shitty Hammock',
    total: {
      $numberLong: '16',
    },
    unitName: 'SKA012',
    url: 'ipfs://bafybeiac4ukujbv4qnp7cuqqrmfuht74umoabmencvvsnuu7pbecujtke4#i',
    note: {
      json: {
        standard: 'arc69',
        mime_type: 'image/png',
        external_url: 'https://www.shittykitties.art',
        description: 'Shitty Kitties Accessories is a collection of NFTs used as rewards for holders of First and Second Litter Shitty Kitties NFTs.',
        properties: {
          Quantity: '16',
          Background: 'Light Blue',
          'Minimum Kitties for Reward': '3',
        },
      },
    },
    enricher: {
      mediaLen: {
        $numberLong: '693872',
      },
      mediaType: 'image/png',
    },
  },
  {
    id: 867652300,
    creator: '7SNDPEPR7APYXCARY2YD7ZM4XKLSOXU3ESDLCHXFQ66HLUFCBOAVIX5T3U',
    name: 'Shitty Collars',

    unitName: 'SKA013',
    url: 'ipfs://bafybeig4tjr23pzeuzb5rnumrtp53l5zi5d5uth7jp4dcngpdzqb7of2aa#i',
    note: {
      json: {
        standard: 'arc69',
        mime_type: 'image/png',
        external_url: 'https://www.shittykitties.art',
        description: 'Shitty Kitties Accessories is a collection of NFTs used as rewards for holders of First and Second Litter Shitty Kitties NFTs.',
        properties: {
          Quantity: '50',
          Background: 'Yellow',
          'Minimum Kitties for Reward': '1',
        },
      },
    },
    enricher: {
      mediaLen: {
        $numberLong: '816394',
      },
      mediaType: 'image/png',
    },
  },
];

export default assets;
